import { useI18n } from 'hooks/useI18n';
import { useRouter } from 'next/router';
import {
  CartesianGrid,
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts';
import MethodologyAnchor from '../../shared/methodologyAnchor/MethodologyAnchor';
import { StyledRecharts } from '../../shared/recharts/Recharts.styled';
import { AVERAGESALARYBYLANGUAGE } from '../Benefits.constants';

const AverageSalaryByLanguage: React.FC = () => {
  const { t } = useI18n('developer-career-report-2023');
  const { locale } = useRouter();

  const averageSalaryByLanguage = AVERAGESALARYBYLANGUAGE(locale);

  return (
    <div>
      <StyledRecharts className="dark vertical-legend">
        <ResponsiveContainer height={400} width="99%" minWidth={600}>
          <LineChart
            data={averageSalaryByLanguage}
            margin={{ left: 10, bottom: 20 }}
          >
            <CartesianGrid strokeDasharray="1 1 " stroke="#353241" />
            <XAxis
              dataKey="years"
              tickLine={false}
              tickMargin={8}
              label={{
                value: t(
                  'mandecar23.benefits.average-salary-language.years-label'
                ),
                position: 'insideBottom',
                offset: -13,
                style: { transformOrigin: 'center center' }
              }}
            />
            <YAxis
              tickLine={false}
              tickMargin={10}
              tickFormatter={(tick) => {
                return `€${tick}K`;
              }}
              label={{
                value: t(
                  'mandecar23.benefits.average-salary-language.salary-label'
                ),
                position: 'insideLeft',
                offset: -8,
                angle: -90
              }}
            />
            <Tooltip
              cursor={{ fill: 'transparent' }}
              labelStyle={{
                borderBottom: '1px solid #4d485c',
                marginBottom: '6px',
                fontWeight: 900
              }}
              separator=": "
              formatter={(value: number) => '€' + value.toFixed(1) + 'K'}
              labelFormatter={(label: string) =>
                label +
                ' ' +
                t('mandecar23.benefits.average-salary-language.years-label')
              }
              wrapperClassName="tooltip-x"
            />
            <Legend
              layout="vertical"
              align="right"
              verticalAlign="top"
              iconType="square"
              width={120}
            />
            <Line
              dataKey="JavaScript"
              dot={false}
              strokeWidth={2}
              stroke="#666666"
            />
            <Line dataKey="PHP" dot={false} strokeWidth={2} stroke="#E7278A" />
            <Line dataKey="CSS" dot={false} strokeWidth={2} stroke="#E41B1E" />
            <Line dataKey="HTML" dot={false} strokeWidth={2} stroke="#E3A702" />

            <Line dataKey="SQL" dot={false} strokeWidth={2} stroke="#65A41E" />
            <Line
              dataKey="Python"
              dot={false}
              strokeWidth={2}
              stroke="#A6761D"
            />
            <Line
              dataKey="JAVA"
              name="Java"
              dot={false}
              strokeWidth={2}
              stroke="#D95F02"
            />
            <Line dataKey="C#" dot={false} strokeWidth={2} stroke="#1B9D76" />
            <Line dataKey="C++" dot={false} strokeWidth={2} stroke="#746FB3" />
            <Line
              dataKey="TypeScript"
              dot={false}
              strokeWidth={2}
              stroke="#1E77B3"
            />
          </LineChart>
        </ResponsiveContainer>
      </StyledRecharts>
      <MethodologyAnchor />
    </div>
  );
};

export default AverageSalaryByLanguage;
